import { render } from "./PaymentType.vue?vue&type=template&id=383b5026"
import script from "./PaymentType.vue?vue&type=script&lang=js"
export * from "./PaymentType.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__